import ar from './ar.json';
import en from './en.json';

/** Generic copy every surface shares — actions, states, error text (U8). */
export const commonCatalogs = { ar, en };
